import styled from "styled-components";
import BaseSearcherButton from "../../../searcher/searcher-button/index.js";
export const SearcherButton = styled(BaseSearcherButton).withConfig({
    displayName: "styled__SearcherButton",
    componentId: "sc-7036f83e-0"
})`
	${({ theme  })=>theme.media.down('lg')} {
		button {
			min-width: 120px;
			max-width: 120px;
		}
	}
`;

//# sourceMappingURL=styled.js.map